import { OrderEnum } from './types.es.js';

const RETURN_FILTERABLE = [
  "FILTER_TYPE_ATTRIBUTE",
  "FILTER_TYPE_BRAND",
  "FILTER_TYPE_PRICE",
  "FILTER_TYPE_CLEARANCE"
];
const PRIMITIVE_PAYLOAD_FILTER = [
  "hasPromotions",
  "inStockOnly",
  "returnAllVariants",
  "priceLte",
  "priceGte"
];
const ARRAY_OF_NUMBER_PAYLOAD_FILTER = [
  "clearanceTypeIds",
  "masterCategoryIds"
];
const ARRAY_OF_STRING_PAYLOAD_FILTER = [
  "skus",
  "excludedSkus",
  "tags",
  "providerIds",
  "sellerIds",
  "brands"
];
const ORDER_PAYLOAD_SORTING = {
  desc: OrderEnum.ORDER_BY_DESCENDING,
  asc: OrderEnum.ORDER_BY_ASCENDING,
  DESC: OrderEnum.ORDER_BY_DESCENDING,
  ASC: OrderEnum.ORDER_BY_ASCENDING
};

export { ARRAY_OF_NUMBER_PAYLOAD_FILTER, ARRAY_OF_STRING_PAYLOAD_FILTER, ORDER_PAYLOAD_SORTING, PRIMITIVE_PAYLOAD_FILTER, RETURN_FILTERABLE };
